package flagpack.icons.large

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Turkmenistan Flag (32x24dp)
 *
 * - ISO Alpha-2: TM
 * - ISO Alpha-3: TKM
 * - ISO Numeric: 795
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Large.Turkmenistan: ImageVector by lazy {
    ImageVector.Builder(
        name = "Turkmenistan:TM:TKM:795:Large",
        defaultWidth = 32.dp,
        defaultHeight = 24.dp,
        viewportWidth = 32f,
        viewportHeight = 24f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF29C470)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        ) {
            path(fill = SolidColor(Color(0xFFC51918))) {
                moveTo(2f, -0.323f)
                horizontalLineToRelative(10f)
                verticalLineToRelative(26.323f)
                horizontalLineToRelative(-10f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(2f, -0.323f)
                horizontalLineToRelative(10f)
                verticalLineToRelative(26.323f)
                horizontalLineToRelative(-10f)
                close()
            }
        ) {
            path(
                fill = SolidColor(Color(0xFFE8AA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(2.595f, 0.906f)
                lineTo(2.049f, 1.607f)
                lineTo(2f, 1.559f)
                lineTo(2.53f, 0.878f)
                verticalLineTo(0.741f)
                lineTo(2.532f, 0.728f)
                lineTo(2.593f, 0.539f)
                lineTo(2.556f, 0.473f)
                lineTo(2.243f, 0.785f)
                lineTo(2.846f, -0.153f)
                verticalLineTo(0.168f)
                lineTo(2.961f, 0.272f)
                lineTo(3.237f, -0.211f)
                lineTo(2.96f, -0.676f)
                lineTo(2.76f, -0.522f)
                lineTo(2.841f, -0.359f)
                lineTo(2.786f, -0.32f)
                lineTo(2.334f, -1.075f)
                lineTo(2.622f, -0.879f)
                lineTo(2.672f, -0.952f)
                lineTo(2.397f, -1.233f)
                lineTo(2.519f, -1.367f)
                lineTo(2.116f, -1.955f)
                lineTo(2.168f, -2f)
                lineTo(2.606f, -1.36f)
                lineTo(2.493f, -1.235f)
                lineTo(2.762f, -0.961f)
                lineTo(2.638f, -0.782f)
                lineTo(2.555f, -0.838f)
                lineTo(2.713f, -0.575f)
                lineTo(2.978f, -0.779f)
                lineTo(3.316f, -0.212f)
                lineTo(2.977f, 0.381f)
                lineTo(2.78f, 0.203f)
                verticalLineTo(0.075f)
                lineTo(2.582f, 0.383f)
                lineTo(2.666f, 0.53f)
                lineTo(2.595f, 0.748f)
                verticalLineTo(0.906f)
                close()
                moveTo(2.049f, 6.63f)
                lineTo(2.595f, 5.929f)
                verticalLineTo(5.771f)
                lineTo(2.666f, 5.553f)
                lineTo(2.582f, 5.406f)
                lineTo(2.78f, 5.098f)
                verticalLineTo(5.226f)
                lineTo(2.977f, 5.404f)
                lineTo(3.316f, 4.811f)
                lineTo(2.978f, 4.244f)
                lineTo(2.713f, 4.448f)
                lineTo(2.555f, 4.185f)
                lineTo(2.638f, 4.241f)
                lineTo(2.762f, 4.062f)
                lineTo(2.493f, 3.788f)
                lineTo(2.606f, 3.663f)
                lineTo(2.168f, 3.023f)
                lineTo(2.116f, 3.068f)
                lineTo(2.519f, 3.656f)
                lineTo(2.397f, 3.79f)
                lineTo(2.672f, 4.071f)
                lineTo(2.622f, 4.144f)
                lineTo(2.334f, 3.947f)
                lineTo(2.786f, 4.702f)
                lineTo(2.841f, 4.664f)
                lineTo(2.76f, 4.501f)
                lineTo(2.96f, 4.347f)
                lineTo(3.237f, 4.812f)
                lineTo(2.961f, 5.295f)
                lineTo(2.846f, 5.191f)
                verticalLineTo(4.87f)
                lineTo(2.243f, 5.808f)
                lineTo(2.556f, 5.496f)
                lineTo(2.593f, 5.562f)
                lineTo(2.532f, 5.751f)
                lineTo(2.53f, 5.764f)
                verticalLineTo(5.901f)
                lineTo(2f, 6.582f)
                lineTo(2.049f, 6.63f)
                close()
                moveTo(2.595f, 10.508f)
                lineTo(2.049f, 11.21f)
                lineTo(2f, 11.161f)
                lineTo(2.53f, 10.48f)
                verticalLineTo(10.344f)
                lineTo(2.532f, 10.331f)
                lineTo(2.593f, 10.141f)
                lineTo(2.556f, 10.075f)
                lineTo(2.243f, 10.388f)
                lineTo(2.846f, 9.45f)
                verticalLineTo(9.77f)
                lineTo(2.961f, 9.875f)
                lineTo(3.237f, 9.392f)
                lineTo(2.96f, 8.927f)
                lineTo(2.76f, 9.081f)
                lineTo(2.841f, 9.243f)
                lineTo(2.786f, 9.282f)
                lineTo(2.334f, 8.527f)
                lineTo(2.622f, 8.724f)
                lineTo(2.672f, 8.65f)
                lineTo(2.397f, 8.37f)
                lineTo(2.519f, 8.235f)
                lineTo(2.116f, 7.648f)
                lineTo(2.168f, 7.603f)
                lineTo(2.606f, 8.242f)
                lineTo(2.493f, 8.368f)
                lineTo(2.762f, 8.642f)
                lineTo(2.638f, 8.821f)
                lineTo(2.555f, 8.765f)
                lineTo(2.713f, 9.028f)
                lineTo(2.978f, 8.824f)
                lineTo(3.316f, 9.391f)
                lineTo(2.977f, 9.983f)
                lineTo(2.78f, 9.806f)
                verticalLineTo(9.678f)
                lineTo(2.582f, 9.986f)
                lineTo(2.666f, 10.132f)
                lineTo(2.595f, 10.35f)
                verticalLineTo(10.508f)
                close()
                moveTo(2.049f, 15.863f)
                lineTo(2.595f, 15.162f)
                verticalLineTo(15.004f)
                lineTo(2.666f, 14.786f)
                lineTo(2.582f, 14.639f)
                lineTo(2.78f, 14.331f)
                verticalLineTo(14.459f)
                lineTo(2.977f, 14.637f)
                lineTo(3.316f, 14.044f)
                lineTo(2.978f, 13.478f)
                lineTo(2.713f, 13.681f)
                lineTo(2.555f, 13.418f)
                lineTo(2.638f, 13.475f)
                lineTo(2.762f, 13.295f)
                lineTo(2.493f, 13.021f)
                lineTo(2.606f, 12.896f)
                lineTo(2.168f, 12.256f)
                lineTo(2.116f, 12.301f)
                lineTo(2.519f, 12.889f)
                lineTo(2.397f, 13.023f)
                lineTo(2.672f, 13.304f)
                lineTo(2.622f, 13.377f)
                lineTo(2.334f, 13.181f)
                lineTo(2.786f, 13.936f)
                lineTo(2.841f, 13.897f)
                lineTo(2.76f, 13.734f)
                lineTo(2.96f, 13.58f)
                lineTo(3.237f, 14.045f)
                lineTo(2.961f, 14.528f)
                lineTo(2.846f, 14.424f)
                verticalLineTo(14.103f)
                lineTo(2.243f, 15.041f)
                lineTo(2.556f, 14.729f)
                lineTo(2.593f, 14.795f)
                lineTo(2.532f, 14.985f)
                lineTo(2.53f, 14.997f)
                verticalLineTo(15.134f)
                lineTo(2f, 15.815f)
                lineTo(2.049f, 15.863f)
                close()
                moveTo(2.049f, 20f)
                lineTo(2.595f, 19.298f)
                verticalLineTo(19.14f)
                lineTo(2.666f, 18.922f)
                lineTo(2.582f, 18.776f)
                lineTo(2.78f, 18.468f)
                verticalLineTo(18.596f)
                lineTo(2.977f, 18.773f)
                lineTo(3.316f, 18.181f)
                lineTo(2.978f, 17.614f)
                lineTo(2.713f, 17.818f)
                lineTo(2.555f, 17.555f)
                lineTo(2.638f, 17.611f)
                lineTo(2.762f, 17.432f)
                lineTo(2.493f, 17.158f)
                lineTo(2.606f, 17.032f)
                lineTo(2.168f, 16.393f)
                lineTo(2.116f, 16.438f)
                lineTo(2.519f, 17.025f)
                lineTo(2.397f, 17.16f)
                lineTo(2.672f, 17.44f)
                lineTo(2.622f, 17.514f)
                lineTo(2.334f, 17.317f)
                lineTo(2.786f, 18.072f)
                lineTo(2.841f, 18.034f)
                lineTo(2.76f, 17.871f)
                lineTo(2.96f, 17.717f)
                lineTo(3.237f, 18.182f)
                lineTo(2.961f, 18.665f)
                lineTo(2.846f, 18.56f)
                verticalLineTo(18.24f)
                lineTo(2.243f, 19.178f)
                lineTo(2.556f, 18.865f)
                lineTo(2.593f, 18.931f)
                lineTo(2.532f, 19.121f)
                lineTo(2.53f, 19.134f)
                verticalLineTo(19.271f)
                lineTo(2f, 19.951f)
                lineTo(2.049f, 20f)
                close()
                moveTo(11.951f, 20f)
                lineTo(11.405f, 19.298f)
                verticalLineTo(19.14f)
                lineTo(11.334f, 18.922f)
                lineTo(11.418f, 18.776f)
                lineTo(11.22f, 18.468f)
                verticalLineTo(18.596f)
                lineTo(11.023f, 18.773f)
                lineTo(10.684f, 18.181f)
                lineTo(11.022f, 17.614f)
                lineTo(11.287f, 17.818f)
                lineTo(11.445f, 17.555f)
                lineTo(11.362f, 17.611f)
                lineTo(11.238f, 17.432f)
                lineTo(11.507f, 17.158f)
                lineTo(11.394f, 17.032f)
                lineTo(11.832f, 16.393f)
                lineTo(11.884f, 16.438f)
                lineTo(11.481f, 17.025f)
                lineTo(11.603f, 17.16f)
                lineTo(11.328f, 17.44f)
                lineTo(11.378f, 17.514f)
                lineTo(11.666f, 17.317f)
                lineTo(11.214f, 18.072f)
                lineTo(11.159f, 18.034f)
                lineTo(11.24f, 17.871f)
                lineTo(11.04f, 17.717f)
                lineTo(10.763f, 18.182f)
                lineTo(11.039f, 18.665f)
                lineTo(11.154f, 18.56f)
                verticalLineTo(18.24f)
                lineTo(11.757f, 19.178f)
                lineTo(11.444f, 18.865f)
                lineTo(11.407f, 18.931f)
                lineTo(11.468f, 19.121f)
                lineTo(11.47f, 19.134f)
                verticalLineTo(19.271f)
                lineTo(12f, 19.951f)
                lineTo(11.951f, 20f)
                close()
                moveTo(11.405f, 15.162f)
                lineTo(11.951f, 15.863f)
                lineTo(12f, 15.815f)
                lineTo(11.47f, 15.134f)
                verticalLineTo(14.997f)
                lineTo(11.468f, 14.985f)
                lineTo(11.407f, 14.795f)
                lineTo(11.444f, 14.729f)
                lineTo(11.757f, 15.041f)
                lineTo(11.154f, 14.103f)
                verticalLineTo(14.424f)
                lineTo(11.039f, 14.528f)
                lineTo(10.763f, 14.045f)
                lineTo(11.04f, 13.58f)
                lineTo(11.24f, 13.734f)
                lineTo(11.159f, 13.897f)
                lineTo(11.214f, 13.936f)
                lineTo(11.666f, 13.181f)
                lineTo(11.378f, 13.377f)
                lineTo(11.328f, 13.304f)
                lineTo(11.603f, 13.023f)
                lineTo(11.481f, 12.889f)
                lineTo(11.884f, 12.301f)
                lineTo(11.832f, 12.256f)
                lineTo(11.394f, 12.896f)
                lineTo(11.507f, 13.021f)
                lineTo(11.238f, 13.295f)
                lineTo(11.362f, 13.475f)
                lineTo(11.445f, 13.418f)
                lineTo(11.287f, 13.681f)
                lineTo(11.022f, 13.478f)
                lineTo(10.684f, 14.044f)
                lineTo(11.023f, 14.637f)
                lineTo(11.22f, 14.459f)
                verticalLineTo(14.331f)
                lineTo(11.418f, 14.639f)
                lineTo(11.334f, 14.786f)
                lineTo(11.405f, 15.004f)
                verticalLineTo(15.162f)
                close()
                moveTo(11.951f, 11.21f)
                lineTo(11.405f, 10.508f)
                verticalLineTo(10.35f)
                lineTo(11.334f, 10.132f)
                lineTo(11.418f, 9.986f)
                lineTo(11.22f, 9.678f)
                verticalLineTo(9.806f)
                lineTo(11.023f, 9.983f)
                lineTo(10.684f, 9.391f)
                lineTo(11.022f, 8.824f)
                lineTo(11.287f, 9.028f)
                lineTo(11.445f, 8.765f)
                lineTo(11.362f, 8.821f)
                lineTo(11.238f, 8.642f)
                lineTo(11.507f, 8.368f)
                lineTo(11.394f, 8.242f)
                lineTo(11.832f, 7.603f)
                lineTo(11.884f, 7.648f)
                lineTo(11.481f, 8.235f)
                lineTo(11.603f, 8.37f)
                lineTo(11.328f, 8.65f)
                lineTo(11.378f, 8.724f)
                lineTo(11.666f, 8.527f)
                lineTo(11.214f, 9.282f)
                lineTo(11.159f, 9.243f)
                lineTo(11.24f, 9.081f)
                lineTo(11.04f, 8.927f)
                lineTo(10.763f, 9.392f)
                lineTo(11.039f, 9.875f)
                lineTo(11.154f, 9.77f)
                verticalLineTo(9.45f)
                lineTo(11.757f, 10.388f)
                lineTo(11.444f, 10.075f)
                lineTo(11.407f, 10.141f)
                lineTo(11.468f, 10.331f)
                lineTo(11.47f, 10.344f)
                verticalLineTo(10.48f)
                lineTo(12f, 11.161f)
                lineTo(11.951f, 11.21f)
                close()
                moveTo(11.405f, 5.929f)
                lineTo(11.951f, 6.63f)
                lineTo(12f, 6.582f)
                lineTo(11.47f, 5.901f)
                verticalLineTo(5.764f)
                lineTo(11.468f, 5.751f)
                lineTo(11.407f, 5.562f)
                lineTo(11.444f, 5.496f)
                lineTo(11.757f, 5.808f)
                lineTo(11.154f, 4.87f)
                verticalLineTo(5.191f)
                lineTo(11.039f, 5.295f)
                lineTo(10.763f, 4.812f)
                lineTo(11.04f, 4.347f)
                lineTo(11.24f, 4.501f)
                lineTo(11.159f, 4.664f)
                lineTo(11.214f, 4.702f)
                lineTo(11.666f, 3.947f)
                lineTo(11.378f, 4.144f)
                lineTo(11.328f, 4.071f)
                lineTo(11.603f, 3.79f)
                lineTo(11.481f, 3.656f)
                lineTo(11.884f, 3.068f)
                lineTo(11.832f, 3.023f)
                lineTo(11.394f, 3.663f)
                lineTo(11.507f, 3.788f)
                lineTo(11.238f, 4.062f)
                lineTo(11.362f, 4.241f)
                lineTo(11.445f, 4.185f)
                lineTo(11.287f, 4.448f)
                lineTo(11.022f, 4.244f)
                lineTo(10.684f, 4.811f)
                lineTo(11.023f, 5.404f)
                lineTo(11.22f, 5.226f)
                verticalLineTo(5.098f)
                lineTo(11.418f, 5.406f)
                lineTo(11.334f, 5.553f)
                lineTo(11.405f, 5.771f)
                verticalLineTo(5.929f)
                close()
                moveTo(11.951f, 1.607f)
                lineTo(11.405f, 0.906f)
                verticalLineTo(0.748f)
                lineTo(11.334f, 0.53f)
                lineTo(11.418f, 0.383f)
                lineTo(11.22f, 0.075f)
                verticalLineTo(0.203f)
                lineTo(11.023f, 0.381f)
                lineTo(10.684f, -0.212f)
                lineTo(11.022f, -0.779f)
                lineTo(11.287f, -0.575f)
                lineTo(11.445f, -0.838f)
                lineTo(11.362f, -0.782f)
                lineTo(11.238f, -0.961f)
                lineTo(11.507f, -1.235f)
                lineTo(11.394f, -1.36f)
                lineTo(11.832f, -2f)
                lineTo(11.884f, -1.955f)
                lineTo(11.481f, -1.367f)
                lineTo(11.603f, -1.233f)
                lineTo(11.328f, -0.952f)
                lineTo(11.378f, -0.879f)
                lineTo(11.666f, -1.075f)
                lineTo(11.214f, -0.32f)
                lineTo(11.159f, -0.359f)
                lineTo(11.24f, -0.522f)
                lineTo(11.04f, -0.676f)
                lineTo(10.763f, -0.211f)
                lineTo(11.039f, 0.272f)
                lineTo(11.154f, 0.168f)
                verticalLineTo(-0.153f)
                lineTo(11.757f, 0.785f)
                lineTo(11.444f, 0.473f)
                lineTo(11.407f, 0.539f)
                lineTo(11.468f, 0.728f)
                lineTo(11.47f, 0.741f)
                verticalLineTo(0.878f)
                lineTo(12f, 1.559f)
                lineTo(11.951f, 1.607f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF389F5D)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(7.307f, 14.565f)
                horizontalLineTo(8.86f)
                verticalLineTo(14.929f)
                horizontalLineTo(9.214f)
                verticalLineTo(15.221f)
                horizontalLineTo(9.639f)
                verticalLineTo(16.169f)
                horizontalLineTo(9.214f)
                verticalLineTo(16.46f)
                horizontalLineTo(8.86f)
                verticalLineTo(16.752f)
                horizontalLineTo(7.348f)
                lineTo(6.93f, 17.124f)
                lineTo(6.51f, 16.752f)
                horizontalLineTo(5.108f)
                verticalLineTo(16.46f)
                horizontalLineTo(4.754f)
                verticalLineTo(16.169f)
                horizontalLineTo(4.4f)
                verticalLineTo(15.221f)
                horizontalLineTo(4.754f)
                verticalLineTo(14.929f)
                horizontalLineTo(5.108f)
                verticalLineTo(14.565f)
                horizontalLineTo(6.551f)
                lineTo(6.93f, 14.23f)
                lineTo(7.307f, 14.565f)
                close()
            }
            path(fill = SolidColor(Color(0xFFE8AA00))) {
                moveTo(8.86f, 14.565f)
                horizontalLineTo(9.11f)
                verticalLineTo(14.315f)
                horizontalLineTo(8.86f)
                verticalLineTo(14.565f)
                close()
                moveTo(7.307f, 14.565f)
                lineTo(7.141f, 14.751f)
                lineTo(7.212f, 14.815f)
                horizontalLineTo(7.307f)
                verticalLineTo(14.565f)
                close()
                moveTo(8.86f, 14.929f)
                horizontalLineTo(8.61f)
                verticalLineTo(15.179f)
                horizontalLineTo(8.86f)
                verticalLineTo(14.929f)
                close()
                moveTo(9.214f, 14.929f)
                horizontalLineTo(9.464f)
                verticalLineTo(14.679f)
                horizontalLineTo(9.214f)
                verticalLineTo(14.929f)
                close()
                moveTo(9.214f, 15.221f)
                horizontalLineTo(8.964f)
                verticalLineTo(15.471f)
                horizontalLineTo(9.214f)
                verticalLineTo(15.221f)
                close()
                moveTo(9.639f, 15.221f)
                horizontalLineTo(9.889f)
                verticalLineTo(14.971f)
                horizontalLineTo(9.639f)
                verticalLineTo(15.221f)
                close()
                moveTo(9.639f, 16.169f)
                verticalLineTo(16.419f)
                horizontalLineTo(9.889f)
                verticalLineTo(16.169f)
                horizontalLineTo(9.639f)
                close()
                moveTo(9.214f, 16.169f)
                verticalLineTo(15.919f)
                horizontalLineTo(8.964f)
                verticalLineTo(16.169f)
                horizontalLineTo(9.214f)
                close()
                moveTo(9.214f, 16.46f)
                verticalLineTo(16.71f)
                horizontalLineTo(9.464f)
                verticalLineTo(16.46f)
                horizontalLineTo(9.214f)
                close()
                moveTo(8.86f, 16.46f)
                verticalLineTo(16.21f)
                horizontalLineTo(8.61f)
                verticalLineTo(16.46f)
                horizontalLineTo(8.86f)
                close()
                moveTo(8.86f, 16.752f)
                verticalLineTo(17.002f)
                horizontalLineTo(9.11f)
                verticalLineTo(16.752f)
                horizontalLineTo(8.86f)
                close()
                moveTo(7.348f, 16.752f)
                verticalLineTo(16.502f)
                horizontalLineTo(7.253f)
                lineTo(7.182f, 16.565f)
                lineTo(7.348f, 16.752f)
                close()
                moveTo(6.93f, 17.124f)
                lineTo(6.764f, 17.311f)
                lineTo(6.93f, 17.458f)
                lineTo(7.096f, 17.311f)
                lineTo(6.93f, 17.124f)
                close()
                moveTo(6.51f, 16.752f)
                lineTo(6.675f, 16.565f)
                lineTo(6.604f, 16.502f)
                horizontalLineTo(6.51f)
                verticalLineTo(16.752f)
                close()
                moveTo(5.108f, 16.752f)
                horizontalLineTo(4.858f)
                verticalLineTo(17.002f)
                horizontalLineTo(5.108f)
                verticalLineTo(16.752f)
                close()
                moveTo(5.108f, 16.46f)
                horizontalLineTo(5.358f)
                verticalLineTo(16.21f)
                horizontalLineTo(5.108f)
                verticalLineTo(16.46f)
                close()
                moveTo(4.754f, 16.46f)
                horizontalLineTo(4.504f)
                verticalLineTo(16.71f)
                horizontalLineTo(4.754f)
                verticalLineTo(16.46f)
                close()
                moveTo(4.754f, 16.169f)
                horizontalLineTo(5.004f)
                verticalLineTo(15.919f)
                horizontalLineTo(4.754f)
                verticalLineTo(16.169f)
                close()
                moveTo(4.4f, 16.169f)
                horizontalLineTo(4.15f)
                verticalLineTo(16.419f)
                horizontalLineTo(4.4f)
                verticalLineTo(16.169f)
                close()
                moveTo(4.4f, 15.221f)
                verticalLineTo(14.971f)
                horizontalLineTo(4.15f)
                verticalLineTo(15.221f)
                horizontalLineTo(4.4f)
                close()
                moveTo(4.754f, 15.221f)
                verticalLineTo(15.471f)
                horizontalLineTo(5.004f)
                verticalLineTo(15.221f)
                horizontalLineTo(4.754f)
                close()
                moveTo(4.754f, 14.929f)
                verticalLineTo(14.679f)
                horizontalLineTo(4.504f)
                verticalLineTo(14.929f)
                horizontalLineTo(4.754f)
                close()
                moveTo(5.108f, 14.929f)
                verticalLineTo(15.179f)
                horizontalLineTo(5.358f)
                verticalLineTo(14.929f)
                horizontalLineTo(5.108f)
                close()
                moveTo(5.108f, 14.565f)
                verticalLineTo(14.315f)
                horizontalLineTo(4.858f)
                verticalLineTo(14.565f)
                horizontalLineTo(5.108f)
                close()
                moveTo(6.551f, 14.565f)
                verticalLineTo(14.815f)
                horizontalLineTo(6.646f)
                lineTo(6.717f, 14.752f)
                lineTo(6.551f, 14.565f)
                close()
                moveTo(6.93f, 14.23f)
                lineTo(7.096f, 14.043f)
                lineTo(6.93f, 13.896f)
                lineTo(6.764f, 14.042f)
                lineTo(6.93f, 14.23f)
                close()
                moveTo(8.86f, 14.315f)
                horizontalLineTo(7.307f)
                verticalLineTo(14.815f)
                horizontalLineTo(8.86f)
                verticalLineTo(14.315f)
                close()
                moveTo(9.11f, 14.929f)
                verticalLineTo(14.565f)
                horizontalLineTo(8.61f)
                verticalLineTo(14.929f)
                horizontalLineTo(9.11f)
                close()
                moveTo(9.214f, 14.679f)
                horizontalLineTo(8.86f)
                verticalLineTo(15.179f)
                horizontalLineTo(9.214f)
                verticalLineTo(14.679f)
                close()
                moveTo(9.464f, 15.221f)
                verticalLineTo(14.929f)
                horizontalLineTo(8.964f)
                verticalLineTo(15.221f)
                horizontalLineTo(9.464f)
                close()
                moveTo(9.639f, 14.971f)
                horizontalLineTo(9.214f)
                verticalLineTo(15.471f)
                horizontalLineTo(9.639f)
                verticalLineTo(14.971f)
                close()
                moveTo(9.889f, 16.169f)
                verticalLineTo(15.221f)
                horizontalLineTo(9.389f)
                verticalLineTo(16.169f)
                horizontalLineTo(9.889f)
                close()
                moveTo(9.214f, 16.419f)
                horizontalLineTo(9.639f)
                verticalLineTo(15.919f)
                horizontalLineTo(9.214f)
                verticalLineTo(16.419f)
                close()
                moveTo(9.464f, 16.46f)
                verticalLineTo(16.169f)
                horizontalLineTo(8.964f)
                verticalLineTo(16.46f)
                horizontalLineTo(9.464f)
                close()
                moveTo(8.86f, 16.71f)
                horizontalLineTo(9.214f)
                verticalLineTo(16.21f)
                horizontalLineTo(8.86f)
                verticalLineTo(16.71f)
                close()
                moveTo(9.11f, 16.752f)
                verticalLineTo(16.46f)
                horizontalLineTo(8.61f)
                verticalLineTo(16.752f)
                horizontalLineTo(9.11f)
                close()
                moveTo(7.348f, 17.002f)
                horizontalLineTo(8.86f)
                verticalLineTo(16.502f)
                horizontalLineTo(7.348f)
                verticalLineTo(17.002f)
                close()
                moveTo(7.096f, 17.311f)
                lineTo(7.514f, 16.939f)
                lineTo(7.182f, 16.565f)
                lineTo(6.764f, 16.937f)
                lineTo(7.096f, 17.311f)
                close()
                moveTo(6.344f, 16.939f)
                lineTo(6.764f, 17.311f)
                lineTo(7.095f, 16.937f)
                lineTo(6.675f, 16.565f)
                lineTo(6.344f, 16.939f)
                close()
                moveTo(5.108f, 17.002f)
                horizontalLineTo(6.51f)
                verticalLineTo(16.502f)
                horizontalLineTo(5.108f)
                verticalLineTo(17.002f)
                close()
                moveTo(4.858f, 16.46f)
                verticalLineTo(16.752f)
                horizontalLineTo(5.358f)
                verticalLineTo(16.46f)
                horizontalLineTo(4.858f)
                close()
                moveTo(4.754f, 16.71f)
                horizontalLineTo(5.108f)
                verticalLineTo(16.21f)
                horizontalLineTo(4.754f)
                verticalLineTo(16.71f)
                close()
                moveTo(4.504f, 16.169f)
                verticalLineTo(16.46f)
                horizontalLineTo(5.004f)
                verticalLineTo(16.169f)
                horizontalLineTo(4.504f)
                close()
                moveTo(4.4f, 16.419f)
                horizontalLineTo(4.754f)
                verticalLineTo(15.919f)
                horizontalLineTo(4.4f)
                verticalLineTo(16.419f)
                close()
                moveTo(4.15f, 15.221f)
                verticalLineTo(16.169f)
                horizontalLineTo(4.65f)
                verticalLineTo(15.221f)
                horizontalLineTo(4.15f)
                close()
                moveTo(4.754f, 14.971f)
                horizontalLineTo(4.4f)
                verticalLineTo(15.471f)
                horizontalLineTo(4.754f)
                verticalLineTo(14.971f)
                close()
                moveTo(4.504f, 14.929f)
                verticalLineTo(15.221f)
                horizontalLineTo(5.004f)
                verticalLineTo(14.929f)
                horizontalLineTo(4.504f)
                close()
                moveTo(5.108f, 14.679f)
                horizontalLineTo(4.754f)
                verticalLineTo(15.179f)
                horizontalLineTo(5.108f)
                verticalLineTo(14.679f)
                close()
                moveTo(4.858f, 14.565f)
                verticalLineTo(14.929f)
                horizontalLineTo(5.358f)
                verticalLineTo(14.565f)
                horizontalLineTo(4.858f)
                close()
                moveTo(6.551f, 14.315f)
                horizontalLineTo(5.108f)
                verticalLineTo(14.815f)
                horizontalLineTo(6.551f)
                verticalLineTo(14.315f)
                close()
                moveTo(6.717f, 14.752f)
                lineTo(7.095f, 14.417f)
                lineTo(6.764f, 14.042f)
                lineTo(6.386f, 14.377f)
                lineTo(6.717f, 14.752f)
                close()
                moveTo(6.764f, 14.417f)
                lineTo(7.141f, 14.751f)
                lineTo(7.473f, 14.378f)
                lineTo(7.096f, 14.043f)
                lineTo(6.764f, 14.417f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFC51918)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(5.315f, 15.407f)
                verticalLineTo(14.763f)
                horizontalLineTo(6.066f)
                lineTo(5.315f, 15.407f)
                close()
                moveTo(8.473f, 15.407f)
                verticalLineTo(14.763f)
                horizontalLineTo(7.722f)
                lineTo(8.473f, 15.407f)
                close()
                moveTo(5.315f, 16.574f)
                verticalLineTo(15.93f)
                lineTo(6.066f, 16.574f)
                horizontalLineTo(5.315f)
                close()
                moveTo(8.473f, 15.93f)
                verticalLineTo(16.574f)
                horizontalLineTo(7.722f)
                lineTo(8.473f, 15.93f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE8AA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(6.645f, 14.818f)
                lineTo(6.904f, 14.479f)
                lineTo(7.16f, 14.818f)
                horizontalLineTo(6.645f)
                close()
                moveTo(6.645f, 15.135f)
                lineTo(6.904f, 15.475f)
                lineTo(7.16f, 15.135f)
                horizontalLineTo(6.645f)
                close()
                moveTo(6.904f, 15.938f)
                lineTo(6.645f, 16.277f)
                horizontalLineTo(7.16f)
                lineTo(6.904f, 15.938f)
                close()
                moveTo(6.645f, 16.594f)
                lineTo(6.904f, 16.933f)
                lineTo(7.16f, 16.594f)
                horizontalLineTo(6.645f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFAF0100)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(6.65f, 14.778f)
                verticalLineTo(14.924f)
                horizontalLineTo(6.502f)
                verticalLineTo(15.124f)
                horizontalLineTo(6.65f)
                verticalLineTo(15.27f)
                horizontalLineTo(7.17f)
                verticalLineTo(15.124f)
                horizontalLineTo(7.318f)
                verticalLineTo(14.924f)
                horizontalLineTo(7.17f)
                verticalLineTo(14.778f)
                horizontalLineTo(6.65f)
                close()
                moveTo(7.17f, 16.382f)
                verticalLineTo(16.237f)
                horizontalLineTo(6.65f)
                verticalLineTo(16.382f)
                horizontalLineTo(6.502f)
                verticalLineTo(16.583f)
                horizontalLineTo(6.65f)
                verticalLineTo(16.728f)
                horizontalLineTo(7.17f)
                verticalLineTo(16.583f)
                horizontalLineTo(7.318f)
                verticalLineTo(16.382f)
                horizontalLineTo(7.17f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFAF0100)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(5.654f, 15.549f)
                lineTo(5.901f, 15.208f)
                lineTo(6.144f, 15.549f)
                horizontalLineTo(5.654f)
                close()
                moveTo(5.654f, 15.868f)
                lineTo(5.901f, 16.208f)
                lineTo(6.144f, 15.868f)
                horizontalLineTo(5.654f)
                close()
                moveTo(7.954f, 15.208f)
                lineTo(7.707f, 15.549f)
                horizontalLineTo(8.197f)
                lineTo(7.954f, 15.208f)
                close()
                moveTo(7.707f, 15.868f)
                lineTo(7.954f, 16.208f)
                lineTo(8.197f, 15.868f)
                horizontalLineTo(7.707f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE8AA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(5.652f, 15.507f)
                verticalLineTo(15.656f)
                horizontalLineTo(5.511f)
                verticalLineTo(15.86f)
                horizontalLineTo(5.652f)
                verticalLineTo(16.009f)
                horizontalLineTo(6.146f)
                verticalLineTo(15.86f)
                horizontalLineTo(6.288f)
                verticalLineTo(15.656f)
                horizontalLineTo(6.146f)
                verticalLineTo(15.507f)
                horizontalLineTo(5.652f)
                close()
                moveTo(8.199f, 15.656f)
                verticalLineTo(15.507f)
                horizontalLineTo(7.705f)
                verticalLineTo(15.656f)
                horizontalLineTo(7.564f)
                verticalLineTo(15.86f)
                horizontalLineTo(7.705f)
                verticalLineTo(16.009f)
                horizontalLineTo(8.199f)
                verticalLineTo(15.86f)
                horizontalLineTo(8.341f)
                verticalLineTo(15.656f)
                horizontalLineTo(8.199f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(6.217f, 17.251f)
                lineTo(4.445f, 18.25f)
                verticalLineTo(19.905f)
                lineTo(6.217f, 20.945f)
                horizontalLineTo(8.136f)
                lineTo(9.949f, 19.905f)
                verticalLineTo(18.25f)
                lineTo(8.136f, 17.251f)
                horizontalLineTo(6.217f)
                close()
            }
        ) {
            path(fill = SolidColor(Color(0xFFE8AA00))) {
                moveTo(4.471f, 19.096f)
                horizontalLineTo(7.232f)
                verticalLineTo(20.919f)
                horizontalLineTo(4.471f)
                verticalLineTo(19.096f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF9E8E7))) {
                moveTo(4.188f, 17.273f)
                horizontalLineToRelative(3.044f)
                verticalLineToRelative(1.823f)
                horizontalLineToRelative(-3.044f)
                close()
            }
            path(fill = SolidColor(Color(0xFFE8AA00))) {
                moveTo(4.896f, 18.335f)
                lineTo(5.812f, 17.783f)
                verticalLineTo(18.335f)
                horizontalLineTo(4.896f)
                close()
            }
            path(fill = SolidColor(Color(0xFFE8AA00))) {
                moveTo(10.276f, 17.273f)
                lineToRelative(-3.044f, 0f)
                lineToRelative(-0f, 1.823f)
                lineToRelative(3.044f, 0f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF9E8E7))) {
                moveTo(9.356f, 18.335f)
                lineTo(8.439f, 17.783f)
                verticalLineTo(18.335f)
                horizontalLineTo(9.356f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF9E8E7))) {
                moveTo(9.993f, 20.919f)
                lineToRelative(-2.761f, -0f)
                lineToRelative(-0f, -1.823f)
                lineToRelative(2.761f, -0f)
                close()
            }
            path(fill = SolidColor(Color(0xFFE8AA00))) {
                moveTo(9.285f, 19.856f)
                lineTo(8.368f, 20.408f)
                verticalLineTo(19.856f)
                horizontalLineTo(9.285f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFCFCFC))) {
                moveTo(4.896f, 19.741f)
                lineTo(5.812f, 20.293f)
                verticalLineTo(19.741f)
                horizontalLineTo(4.896f)
                close()
            }
        }
        path(
            fill = SolidColor(Color(0xFFC51918)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(6.241f, 18.367f)
            horizontalLineTo(6.701f)
            lineTo(7.161f, 18.221f)
            lineTo(7.621f, 18.367f)
            horizontalLineTo(8.081f)
            verticalLineTo(19.752f)
            horizontalLineTo(7.621f)
            lineTo(7.161f, 19.971f)
            lineTo(6.701f, 19.752f)
            horizontalLineTo(6.241f)
            verticalLineTo(18.367f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFC9343F)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(7.798f, 17.538f)
            horizontalLineTo(8.048f)
            verticalLineTo(17.82f)
            horizontalLineTo(8.151f)
            verticalLineTo(18.02f)
            horizontalLineTo(8.048f)
            verticalLineTo(18.127f)
            horizontalLineTo(7.798f)
            verticalLineTo(17.538f)
            close()
            moveTo(5.287f, 18.413f)
            horizontalLineTo(5.037f)
            verticalLineTo(19.002f)
            horizontalLineTo(5.287f)
            verticalLineTo(18.895f)
            horizontalLineTo(5.39f)
            verticalLineTo(18.695f)
            horizontalLineTo(5.287f)
            verticalLineTo(18.413f)
            close()
            moveTo(5.641f, 18.413f)
            horizontalLineTo(5.391f)
            verticalLineTo(19.002f)
            horizontalLineTo(5.641f)
            verticalLineTo(18.413f)
            close()
            moveTo(5.287f, 19.142f)
            horizontalLineTo(5.037f)
            verticalLineTo(19.732f)
            horizontalLineTo(5.287f)
            verticalLineTo(19.624f)
            horizontalLineTo(5.39f)
            verticalLineTo(19.424f)
            horizontalLineTo(5.287f)
            verticalLineTo(19.142f)
            close()
            moveTo(5.391f, 19.142f)
            horizontalLineTo(5.641f)
            verticalLineTo(19.732f)
            horizontalLineTo(5.391f)
            verticalLineTo(19.142f)
            close()
            moveTo(8.931f, 18.413f)
            horizontalLineTo(9.181f)
            verticalLineTo(18.695f)
            horizontalLineTo(9.283f)
            verticalLineTo(18.895f)
            horizontalLineTo(9.181f)
            verticalLineTo(19.002f)
            horizontalLineTo(8.931f)
            verticalLineTo(18.413f)
            close()
            moveTo(9.535f, 18.413f)
            horizontalLineTo(9.285f)
            verticalLineTo(19.002f)
            horizontalLineTo(9.535f)
            verticalLineTo(18.413f)
            close()
            moveTo(9.181f, 19.142f)
            horizontalLineTo(8.931f)
            verticalLineTo(19.732f)
            horizontalLineTo(9.181f)
            verticalLineTo(19.624f)
            horizontalLineTo(9.283f)
            verticalLineTo(19.424f)
            horizontalLineTo(9.181f)
            verticalLineTo(19.142f)
            close()
            moveTo(9.285f, 19.142f)
            horizontalLineTo(9.535f)
            verticalLineTo(19.732f)
            horizontalLineTo(9.285f)
            verticalLineTo(19.142f)
            close()
            moveTo(8.402f, 17.538f)
            horizontalLineTo(8.152f)
            verticalLineTo(18.127f)
            horizontalLineTo(8.402f)
            verticalLineTo(17.538f)
            close()
            moveTo(6.349f, 17.538f)
            horizontalLineTo(6.099f)
            verticalLineTo(18.127f)
            horizontalLineTo(6.349f)
            verticalLineTo(18.02f)
            horizontalLineTo(6.452f)
            verticalLineTo(17.82f)
            horizontalLineTo(6.349f)
            verticalLineTo(17.538f)
            close()
            moveTo(6.453f, 17.538f)
            horizontalLineTo(6.703f)
            verticalLineTo(18.127f)
            horizontalLineTo(6.453f)
            verticalLineTo(17.538f)
            close()
            moveTo(7.798f, 20.017f)
            horizontalLineTo(8.048f)
            verticalLineTo(20.299f)
            horizontalLineTo(8.151f)
            verticalLineTo(20.499f)
            horizontalLineTo(8.048f)
            verticalLineTo(20.607f)
            horizontalLineTo(7.798f)
            verticalLineTo(20.017f)
            close()
            moveTo(8.402f, 20.017f)
            horizontalLineTo(8.152f)
            verticalLineTo(20.607f)
            horizontalLineTo(8.402f)
            verticalLineTo(20.017f)
            close()
            moveTo(6.349f, 20.017f)
            horizontalLineTo(6.099f)
            verticalLineTo(20.607f)
            horizontalLineTo(6.349f)
            verticalLineTo(20.499f)
            horizontalLineTo(6.452f)
            verticalLineTo(20.299f)
            horizontalLineTo(6.349f)
            verticalLineTo(20.017f)
            close()
            moveTo(6.453f, 20.017f)
            horizontalLineTo(6.703f)
            verticalLineTo(20.607f)
            horizontalLineTo(6.453f)
            verticalLineTo(20.017f)
            close()
        }
        path(
            fill = SolidColor(Color.White),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(7.025f, 18.666f)
            horizontalLineTo(7.096f)
            verticalLineTo(18.468f)
            horizontalLineTo(6.742f)
            verticalLineTo(18.695f)
            horizontalLineTo(6.451f)
            verticalLineTo(19.02f)
            horizontalLineTo(6.722f)
            verticalLineTo(18.947f)
            horizontalLineTo(6.521f)
            verticalLineTo(18.768f)
            horizontalLineTo(6.762f)
            lineTo(7.124f, 19.081f)
            lineTo(6.762f, 19.394f)
            horizontalLineTo(6.521f)
            verticalLineTo(19.215f)
            horizontalLineTo(6.722f)
            verticalLineTo(19.142f)
            horizontalLineTo(6.451f)
            verticalLineTo(19.467f)
            horizontalLineTo(6.742f)
            verticalLineTo(19.693f)
            horizontalLineTo(7.096f)
            verticalLineTo(19.495f)
            horizontalLineTo(7.025f)
            verticalLineTo(19.621f)
            horizontalLineTo(6.813f)
            verticalLineTo(19.445f)
            lineTo(7.181f, 19.126f)
            lineTo(7.549f, 19.445f)
            verticalLineTo(19.621f)
            horizontalLineTo(7.337f)
            verticalLineTo(19.495f)
            horizontalLineTo(7.266f)
            verticalLineTo(19.693f)
            horizontalLineTo(7.62f)
            verticalLineTo(19.467f)
            horizontalLineTo(7.911f)
            verticalLineTo(19.142f)
            horizontalLineTo(7.64f)
            verticalLineTo(19.215f)
            horizontalLineTo(7.84f)
            verticalLineTo(19.394f)
            horizontalLineTo(7.6f)
            lineTo(7.238f, 19.081f)
            lineTo(7.6f, 18.768f)
            horizontalLineTo(7.84f)
            verticalLineTo(18.947f)
            horizontalLineTo(7.64f)
            verticalLineTo(19.02f)
            horizontalLineTo(7.911f)
            verticalLineTo(18.695f)
            horizontalLineTo(7.62f)
            verticalLineTo(18.468f)
            horizontalLineTo(7.266f)
            verticalLineTo(18.666f)
            horizontalLineTo(7.337f)
            verticalLineTo(18.541f)
            horizontalLineTo(7.549f)
            verticalLineTo(18.716f)
            lineTo(7.181f, 19.035f)
            lineTo(6.813f, 18.716f)
            verticalLineTo(18.541f)
            horizontalLineTo(7.025f)
            verticalLineTo(18.666f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFE8AA00)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(7.584f, 4.8f)
            horizontalLineTo(6.338f)
            verticalLineTo(8.8f)
            horizontalLineTo(7.584f)
            verticalLineTo(4.8f)
            close()
            moveTo(4.779f, 5.646f)
            horizontalLineTo(5.558f)
            verticalLineTo(7.8f)
            horizontalLineTo(4.779f)
            verticalLineTo(5.646f)
            close()
            moveTo(8.442f, 5.646f)
            horizontalLineTo(9.221f)
            verticalLineTo(7.8f)
            horizontalLineTo(8.442f)
            verticalLineTo(5.646f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF389F5D)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(6.338f, 5.108f)
            horizontalLineTo(5.558f)
            verticalLineTo(8.185f)
            horizontalLineTo(6.338f)
            verticalLineTo(5.108f)
            close()
            moveTo(4.779f, 5.954f)
            horizontalLineTo(4f)
            verticalLineTo(7.415f)
            horizontalLineTo(4.779f)
            verticalLineTo(5.954f)
            close()
            moveTo(9.221f, 5.954f)
            horizontalLineTo(10f)
            verticalLineTo(7.415f)
            horizontalLineTo(9.221f)
            verticalLineTo(5.954f)
            close()
            moveTo(8.364f, 5.108f)
            horizontalLineTo(7.584f)
            verticalLineTo(8.185f)
            horizontalLineTo(8.364f)
            verticalLineTo(5.108f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFE1E5E8)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(6.182f, 5.492f)
            curveTo(6.182f, 5.62f, 6.077f, 5.723f, 5.948f, 5.723f)
            curveTo(5.819f, 5.723f, 5.714f, 5.62f, 5.714f, 5.492f)
            curveTo(5.714f, 5.365f, 5.819f, 5.262f, 5.948f, 5.262f)
            curveTo(6.077f, 5.262f, 6.182f, 5.365f, 6.182f, 5.492f)
            close()
            moveTo(4.623f, 6.262f)
            curveTo(4.623f, 6.389f, 4.519f, 6.492f, 4.39f, 6.492f)
            curveTo(4.26f, 6.492f, 4.156f, 6.389f, 4.156f, 6.262f)
            curveTo(4.156f, 6.134f, 4.26f, 6.031f, 4.39f, 6.031f)
            curveTo(4.519f, 6.031f, 4.623f, 6.134f, 4.623f, 6.262f)
            close()
            moveTo(4.623f, 7.108f)
            curveTo(4.623f, 7.235f, 4.519f, 7.338f, 4.39f, 7.338f)
            curveTo(4.26f, 7.338f, 4.156f, 7.235f, 4.156f, 7.108f)
            curveTo(4.156f, 6.98f, 4.26f, 6.877f, 4.39f, 6.877f)
            curveTo(4.519f, 6.877f, 4.623f, 6.98f, 4.623f, 7.108f)
            close()
            moveTo(5.948f, 8.031f)
            curveTo(6.077f, 8.031f, 6.182f, 7.927f, 6.182f, 7.8f)
            curveTo(6.182f, 7.673f, 6.077f, 7.569f, 5.948f, 7.569f)
            curveTo(5.819f, 7.569f, 5.714f, 7.673f, 5.714f, 7.8f)
            curveTo(5.714f, 7.927f, 5.819f, 8.031f, 5.948f, 8.031f)
            close()
            moveTo(9.61f, 6.492f)
            curveTo(9.739f, 6.492f, 9.844f, 6.389f, 9.844f, 6.262f)
            curveTo(9.844f, 6.134f, 9.739f, 6.031f, 9.61f, 6.031f)
            curveTo(9.481f, 6.031f, 9.377f, 6.134f, 9.377f, 6.262f)
            curveTo(9.377f, 6.389f, 9.481f, 6.492f, 9.61f, 6.492f)
            close()
            moveTo(9.844f, 7.108f)
            curveTo(9.844f, 7.235f, 9.739f, 7.338f, 9.61f, 7.338f)
            curveTo(9.481f, 7.338f, 9.377f, 7.235f, 9.377f, 7.108f)
            curveTo(9.377f, 6.98f, 9.481f, 6.877f, 9.61f, 6.877f)
            curveTo(9.739f, 6.877f, 9.844f, 6.98f, 9.844f, 7.108f)
            close()
            moveTo(7.974f, 8.031f)
            curveTo(8.103f, 8.031f, 8.208f, 7.927f, 8.208f, 7.8f)
            curveTo(8.208f, 7.673f, 8.103f, 7.569f, 7.974f, 7.569f)
            curveTo(7.845f, 7.569f, 7.74f, 7.673f, 7.74f, 7.8f)
            curveTo(7.74f, 7.927f, 7.845f, 8.031f, 7.974f, 8.031f)
            close()
            moveTo(8.208f, 5.492f)
            curveTo(8.208f, 5.62f, 8.103f, 5.723f, 7.974f, 5.723f)
            curveTo(7.845f, 5.723f, 7.74f, 5.62f, 7.74f, 5.492f)
            curveTo(7.74f, 5.365f, 7.845f, 5.262f, 7.974f, 5.262f)
            curveTo(8.103f, 5.262f, 8.208f, 5.365f, 8.208f, 5.492f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFC51918)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(7.195f, 5.185f)
            curveTo(7.195f, 5.312f, 7.09f, 5.415f, 6.961f, 5.415f)
            curveTo(6.832f, 5.415f, 6.727f, 5.312f, 6.727f, 5.185f)
            curveTo(6.727f, 5.057f, 6.832f, 4.954f, 6.961f, 4.954f)
            curveTo(7.09f, 4.954f, 7.195f, 5.057f, 7.195f, 5.185f)
            close()
            moveTo(5.403f, 6.031f)
            curveTo(5.403f, 6.158f, 5.298f, 6.262f, 5.169f, 6.262f)
            curveTo(5.04f, 6.262f, 4.935f, 6.158f, 4.935f, 6.031f)
            curveTo(4.935f, 5.903f, 5.04f, 5.8f, 5.169f, 5.8f)
            curveTo(5.298f, 5.8f, 5.403f, 5.903f, 5.403f, 6.031f)
            close()
            moveTo(6.961f, 8.723f)
            curveTo(7.09f, 8.723f, 7.195f, 8.62f, 7.195f, 8.492f)
            curveTo(7.195f, 8.365f, 7.09f, 8.262f, 6.961f, 8.262f)
            curveTo(6.832f, 8.262f, 6.727f, 8.365f, 6.727f, 8.492f)
            curveTo(6.727f, 8.62f, 6.832f, 8.723f, 6.961f, 8.723f)
            close()
            moveTo(9.065f, 6.031f)
            curveTo(9.065f, 6.158f, 8.96f, 6.262f, 8.831f, 6.262f)
            curveTo(8.702f, 6.262f, 8.597f, 6.158f, 8.597f, 6.031f)
            curveTo(8.597f, 5.903f, 8.702f, 5.8f, 8.831f, 5.8f)
            curveTo(8.96f, 5.8f, 9.065f, 5.903f, 9.065f, 6.031f)
            close()
            moveTo(5.169f, 7.646f)
            curveTo(5.298f, 7.646f, 5.403f, 7.543f, 5.403f, 7.415f)
            curveTo(5.403f, 7.288f, 5.298f, 7.185f, 5.169f, 7.185f)
            curveTo(5.04f, 7.185f, 4.935f, 7.288f, 4.935f, 7.415f)
            curveTo(4.935f, 7.543f, 5.04f, 7.646f, 5.169f, 7.646f)
            close()
            moveTo(9.065f, 7.415f)
            curveTo(9.065f, 7.543f, 8.96f, 7.646f, 8.831f, 7.646f)
            curveTo(8.702f, 7.646f, 8.597f, 7.543f, 8.597f, 7.415f)
            curveTo(8.597f, 7.288f, 8.702f, 7.185f, 8.831f, 7.185f)
            curveTo(8.96f, 7.185f, 9.065f, 7.288f, 9.065f, 7.415f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFC51918)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(5.607f, 6.391f)
            lineTo(6.365f, 5.706f)
            horizontalLineTo(7.597f)
            lineTo(8.461f, 6.492f)
            horizontalLineTo(9.61f)
            verticalLineTo(6.8f)
            horizontalLineTo(8.492f)
            verticalLineTo(6.816f)
            lineTo(7.597f, 7.727f)
            horizontalLineTo(6.365f)
            lineTo(5.607f, 6.905f)
            verticalLineTo(6.8f)
            horizontalLineTo(4.312f)
            verticalLineTo(6.492f)
            horizontalLineTo(5.607f)
            verticalLineTo(6.391f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFE8AA00)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(7.011f, 6.276f)
            lineTo(7.379f, 6.65f)
            lineTo(6.993f, 7.016f)
            lineTo(6.606f, 6.65f)
            lineTo(6.974f, 6.276f)
            lineTo(6.993f, 6.26f)
            lineTo(7.011f, 6.276f)
            close()
            moveTo(7.078f, 7.178f)
            lineTo(7.121f, 7.138f)
            lineTo(7.077f, 7.096f)
            lineTo(7.461f, 6.732f)
            lineTo(7.861f, 7.138f)
            lineTo(7.681f, 7.328f)
            horizontalLineTo(7.574f)
            lineTo(7.376f, 7.453f)
            lineTo(7.078f, 7.178f)
            close()
            moveTo(6.993f, 7.257f)
            lineTo(6.624f, 7.599f)
            lineTo(6.377f, 7.444f)
            horizontalLineTo(6.254f)
            lineTo(5.962f, 7.137f)
            lineTo(6.44f, 6.653f)
            lineTo(5.959f, 6.197f)
            lineTo(6.275f, 5.891f)
            lineTo(6.389f, 5.981f)
            lineTo(6.555f, 5.814f)
            lineTo(6.505f, 5.763f)
            lineTo(6.589f, 5.683f)
            lineTo(6.993f, 6.093f)
            lineTo(7.397f, 5.683f)
            lineTo(7.481f, 5.763f)
            lineTo(7.431f, 5.814f)
            lineTo(7.596f, 5.981f)
            lineTo(7.711f, 5.891f)
            lineTo(8.026f, 6.197f)
            lineTo(7.545f, 6.653f)
            lineTo(8.023f, 7.137f)
            lineTo(7.732f, 7.444f)
            horizontalLineTo(7.608f)
            lineTo(7.362f, 7.599f)
            lineTo(6.993f, 7.257f)
            close()
            moveTo(7.199f, 6.301f)
            lineTo(7.204f, 6.296f)
            lineTo(7.093f, 6.194f)
            lineTo(7.079f, 6.18f)
            lineTo(7.367f, 5.914f)
            lineTo(7.586f, 6.136f)
            lineTo(7.702f, 6.045f)
            lineTo(7.858f, 6.196f)
            lineTo(7.464f, 6.57f)
            lineTo(7.199f, 6.301f)
            close()
            moveTo(6.951f, 7.137f)
            lineTo(6.61f, 7.453f)
            lineTo(6.411f, 7.328f)
            horizontalLineTo(6.304f)
            lineTo(6.124f, 7.138f)
            lineTo(6.524f, 6.732f)
            lineTo(6.951f, 7.137f)
            close()
            moveTo(6.127f, 6.196f)
            lineTo(6.522f, 6.57f)
            lineTo(6.906f, 6.18f)
            lineTo(6.619f, 5.914f)
            lineTo(6.399f, 6.136f)
            lineTo(6.283f, 6.045f)
            lineTo(6.127f, 6.196f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFE8AA00)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(4.448f, 21.442f)
            curveTo(4.239f, 21.176f, 4.098f, 20.997f, 4.061f, 21f)
            curveTo(3.944f, 21.009f, 3.835f, 22.244f, 5.351f, 23.184f)
            curveTo(5.351f, 23.184f, 5.575f, 23.308f, 5.706f, 23.184f)
            curveTo(5.836f, 23.059f, 5.706f, 22.876f, 5.706f, 22.876f)
            curveTo(5.215f, 22.415f, 4.758f, 21.834f, 4.448f, 21.442f)
            lineTo(4.448f, 21.442f)
            lineTo(4.448f, 21.442f)
            close()
            moveTo(9.552f, 21.442f)
            lineTo(9.552f, 21.442f)
            lineTo(9.552f, 21.442f)
            curveTo(9.761f, 21.176f, 9.902f, 20.997f, 9.939f, 21f)
            curveTo(10.056f, 21.009f, 10.165f, 22.244f, 8.649f, 23.184f)
            curveTo(8.649f, 23.184f, 8.425f, 23.308f, 8.294f, 23.184f)
            curveTo(8.164f, 23.059f, 8.294f, 22.876f, 8.294f, 22.876f)
            curveTo(8.785f, 22.415f, 9.242f, 21.834f, 9.552f, 21.442f)
            close()
            moveTo(9.441f, 23.104f)
            curveTo(8.942f, 23.251f, 8.365f, 23.282f, 8.145f, 23.187f)
            curveTo(8.074f, 23.156f, 7.999f, 23.132f, 7.921f, 23.115f)
            curveTo(7.701f, 23.065f, 7.487f, 23.064f, 7.234f, 23.092f)
            curveTo(7.212f, 23.094f, 7.159f, 23.101f, 7.14f, 23.103f)
            lineTo(7.14f, 23.103f)
            lineTo(7.133f, 23.104f)
            curveTo(7.109f, 23.106f, 7.096f, 23.108f, 7.093f, 23.108f)
            curveTo(7.078f, 23.108f, 7.062f, 23.11f, 7.044f, 23.114f)
            curveTo(7.026f, 23.11f, 7.01f, 23.108f, 6.995f, 23.108f)
            curveTo(6.992f, 23.108f, 6.978f, 23.106f, 6.954f, 23.104f)
            curveTo(6.954f, 23.104f, 6.952f, 23.103f, 6.948f, 23.103f)
            curveTo(6.929f, 23.101f, 6.876f, 23.094f, 6.854f, 23.092f)
            curveTo(6.6f, 23.064f, 6.386f, 23.065f, 6.167f, 23.115f)
            curveTo(6.088f, 23.132f, 6.013f, 23.156f, 5.943f, 23.187f)
            curveTo(5.722f, 23.282f, 5.145f, 23.251f, 4.647f, 23.104f)
            curveTo(4.647f, 23.104f, 5.554f, 23.468f, 6.092f, 23.306f)
            curveTo(6.145f, 23.284f, 6.2f, 23.266f, 6.258f, 23.253f)
            curveTo(6.411f, 23.218f, 6.568f, 23.215f, 6.757f, 23.233f)
            curveTo(6.677f, 23.27f, 6.585f, 23.312f, 6.478f, 23.356f)
            verticalLineTo(23.4f)
            curveTo(6.69f, 23.314f, 6.938f, 23.273f, 7.044f, 23.261f)
            curveTo(7.15f, 23.273f, 7.398f, 23.314f, 7.61f, 23.4f)
            verticalLineTo(23.356f)
            curveTo(7.503f, 23.312f, 7.41f, 23.27f, 7.331f, 23.233f)
            curveTo(7.52f, 23.215f, 7.677f, 23.218f, 7.83f, 23.253f)
            curveTo(7.888f, 23.266f, 7.943f, 23.284f, 7.995f, 23.306f)
            curveTo(8.534f, 23.468f, 9.441f, 23.104f, 9.441f, 23.104f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF389F5D)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(5.764f, 9.977f)
            lineTo(4.512f, 11.081f)
            verticalLineTo(12.131f)
            lineTo(5.607f, 13.231f)
            horizontalLineTo(7.841f)
            lineTo(9.073f, 12.058f)
            verticalLineTo(11.163f)
            lineTo(7.841f, 9.977f)
            horizontalLineTo(5.764f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFC51918)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(6.195f, 10.094f)
            horizontalLineTo(5.911f)
            verticalLineTo(10.313f)
            horizontalLineTo(6.195f)
            verticalLineTo(10.094f)
            close()
            moveTo(6.195f, 12.954f)
            horizontalLineTo(5.911f)
            verticalLineTo(13.173f)
            horizontalLineTo(6.195f)
            verticalLineTo(12.954f)
            close()
            moveTo(6.619f, 12.954f)
            horizontalLineTo(6.903f)
            verticalLineTo(13.173f)
            horizontalLineTo(6.619f)
            verticalLineTo(12.954f)
            close()
            moveTo(6.903f, 10.094f)
            horizontalLineTo(6.619f)
            verticalLineTo(10.313f)
            horizontalLineTo(6.903f)
            verticalLineTo(10.094f)
            close()
            moveTo(7.327f, 12.954f)
            horizontalLineTo(7.611f)
            verticalLineTo(13.173f)
            horizontalLineTo(7.327f)
            verticalLineTo(12.954f)
            close()
            moveTo(7.611f, 10.094f)
            horizontalLineTo(7.327f)
            verticalLineTo(10.313f)
            horizontalLineTo(7.611f)
            verticalLineTo(10.094f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFE8AA00)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(6.554f, 10.038f)
            horizontalLineTo(6.266f)
            verticalLineTo(10.256f)
            horizontalLineTo(6.554f)
            verticalLineTo(10.038f)
            close()
            moveTo(6.554f, 12.954f)
            horizontalLineTo(6.266f)
            verticalLineTo(13.173f)
            horizontalLineTo(6.554f)
            verticalLineTo(12.954f)
            close()
            moveTo(6.986f, 10.038f)
            horizontalLineTo(7.274f)
            verticalLineTo(10.256f)
            horizontalLineTo(6.986f)
            verticalLineTo(10.038f)
            close()
            moveTo(7.274f, 12.954f)
            horizontalLineTo(6.986f)
            verticalLineTo(13.173f)
            horizontalLineTo(7.274f)
            verticalLineTo(12.954f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF750100)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(4.914f, 9.842f)
            horizontalLineTo(8.694f)
            verticalLineTo(10.426f)
            horizontalLineTo(9.235f)
            verticalLineTo(12.841f)
            horizontalLineTo(8.694f)
            verticalLineTo(13.34f)
            horizontalLineTo(4.914f)
            verticalLineTo(12.841f)
            horizontalLineTo(4.326f)
            verticalLineTo(10.426f)
            horizontalLineTo(4.914f)
            verticalLineTo(9.842f)
            close()
            moveTo(5.126f, 10.645f)
            horizontalLineTo(4.538f)
            verticalLineTo(12.622f)
            horizontalLineTo(5.126f)
            verticalLineTo(13.121f)
            horizontalLineTo(8.481f)
            verticalLineTo(12.622f)
            horizontalLineTo(9.023f)
            verticalLineTo(10.645f)
            horizontalLineTo(8.481f)
            verticalLineTo(10.061f)
            horizontalLineTo(5.126f)
            verticalLineTo(10.645f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF389F5D)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(6.407f, 9.6f)
            horizontalLineTo(6.053f)
            verticalLineTo(9.965f)
            horizontalLineTo(6.407f)
            verticalLineTo(9.6f)
            close()
            moveTo(6.973f, 9.6f)
            horizontalLineTo(6.619f)
            verticalLineTo(9.965f)
            horizontalLineTo(6.973f)
            verticalLineTo(9.6f)
            close()
            moveTo(7.186f, 9.6f)
            horizontalLineTo(7.54f)
            verticalLineTo(9.965f)
            horizontalLineTo(7.186f)
            verticalLineTo(9.6f)
            close()
            moveTo(6.407f, 13.246f)
            horizontalLineTo(6.053f)
            verticalLineTo(13.61f)
            horizontalLineTo(6.407f)
            verticalLineTo(13.246f)
            close()
            moveTo(6.619f, 13.246f)
            horizontalLineTo(6.973f)
            verticalLineTo(13.61f)
            horizontalLineTo(6.619f)
            verticalLineTo(13.246f)
            close()
            moveTo(7.54f, 13.246f)
            horizontalLineTo(7.186f)
            verticalLineTo(13.61f)
            horizontalLineTo(7.54f)
            verticalLineTo(13.246f)
            close()
            moveTo(3.995f, 12.438f)
            verticalLineTo(12.084f)
            horizontalLineTo(4.359f)
            verticalLineTo(12.438f)
            horizontalLineTo(3.995f)
            close()
            moveTo(3.995f, 11.501f)
            verticalLineTo(11.855f)
            horizontalLineTo(4.359f)
            verticalLineTo(11.501f)
            horizontalLineTo(3.995f)
            close()
            moveTo(3.995f, 11.272f)
            verticalLineTo(10.918f)
            horizontalLineTo(4.359f)
            verticalLineTo(11.272f)
            horizontalLineTo(3.995f)
            close()
            moveTo(9.092f, 12.084f)
            verticalLineTo(12.438f)
            horizontalLineTo(9.457f)
            verticalLineTo(12.084f)
            horizontalLineTo(9.092f)
            close()
            moveTo(9.092f, 11.855f)
            verticalLineTo(11.501f)
            horizontalLineTo(9.457f)
            verticalLineTo(11.855f)
            horizontalLineTo(9.092f)
            close()
            moveTo(9.092f, 10.918f)
            verticalLineTo(11.272f)
            horizontalLineTo(9.457f)
            verticalLineTo(10.918f)
            horizontalLineTo(9.092f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFC51918)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(5.778f, 10.285f)
            lineTo(5.168f, 10.816f)
            verticalLineTo(12.534f)
            lineTo(5.675f, 12.892f)
            horizontalLineTo(7.871f)
            lineTo(8.377f, 12.534f)
            verticalLineTo(10.816f)
            lineTo(7.806f, 10.285f)
            horizontalLineTo(5.778f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFE1E5E8)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(6.803f, 10.997f)
            lineTo(6.067f, 11.626f)
            horizontalLineTo(6.803f)
            verticalLineTo(10.997f)
            close()
        }
        path(fill = SolidColor(Color(0xFFE8AA00))) {
            moveTo(6.803f, 12.197f)
            lineTo(6.067f, 11.568f)
            horizontalLineTo(6.803f)
            verticalLineTo(12.197f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFE8AA00)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(6.739f, 10.997f)
            lineTo(7.476f, 11.626f)
            horizontalLineTo(6.739f)
            verticalLineTo(10.997f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF29AE66)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(6.772f, 11.796f)
            curveTo(6.895f, 11.796f, 6.995f, 11.696f, 6.995f, 11.573f)
            curveTo(6.995f, 11.45f, 6.895f, 11.35f, 6.772f, 11.35f)
            curveTo(6.649f, 11.35f, 6.549f, 11.45f, 6.549f, 11.573f)
            curveTo(6.549f, 11.696f, 6.649f, 11.796f, 6.772f, 11.796f)
            close()
        }
        path(fill = SolidColor(Color(0xFFE1E5E8))) {
            moveTo(6.739f, 12.197f)
            lineTo(7.476f, 11.568f)
            horizontalLineTo(6.739f)
            verticalLineTo(12.197f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFC51918)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(5.204f, 11.35f)
            horizontalLineTo(4.566f)
            verticalLineTo(11.554f)
            horizontalLineTo(5.204f)
            verticalLineTo(11.35f)
            close()
            moveTo(5.204f, 11.722f)
            horizontalLineTo(4.566f)
            verticalLineTo(11.926f)
            horizontalLineTo(5.204f)
            verticalLineTo(11.722f)
            close()
            moveTo(8.389f, 11.35f)
            horizontalLineTo(9.027f)
            verticalLineTo(11.554f)
            horizontalLineTo(8.389f)
            verticalLineTo(11.35f)
            close()
            moveTo(9.027f, 11.722f)
            horizontalLineTo(8.389f)
            verticalLineTo(11.926f)
            horizontalLineTo(9.027f)
            verticalLineTo(11.722f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFE8AA00)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(5.133f, 11.131f)
            horizontalLineTo(4.566f)
            verticalLineTo(11.354f)
            horizontalLineTo(5.133f)
            verticalLineTo(11.131f)
            close()
            moveTo(5.133f, 11.503f)
            horizontalLineTo(4.566f)
            verticalLineTo(11.726f)
            horizontalLineTo(5.133f)
            verticalLineTo(11.503f)
            close()
            moveTo(4.566f, 11.875f)
            horizontalLineTo(5.133f)
            verticalLineTo(12.098f)
            horizontalLineTo(4.566f)
            verticalLineTo(11.875f)
            close()
            moveTo(8.956f, 11.131f)
            horizontalLineTo(8.389f)
            verticalLineTo(11.354f)
            horizontalLineTo(8.956f)
            verticalLineTo(11.131f)
            close()
            moveTo(8.389f, 11.503f)
            horizontalLineTo(8.956f)
            verticalLineTo(11.726f)
            horizontalLineTo(8.389f)
            verticalLineTo(11.503f)
            close()
            moveTo(8.956f, 11.875f)
            horizontalLineTo(8.389f)
            verticalLineTo(12.098f)
            horizontalLineTo(8.956f)
            verticalLineTo(11.875f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFE8AA00)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(9.985f, 1.59f)
            lineTo(9.983f, 1.996f)
            horizontalLineTo(7.024f)
            lineTo(7.022f, 3.836f)
            horizontalLineTo(6.094f)
            curveTo(5.932f, 3.836f, 5.488f, 3.525f, 5.488f, 3.525f)
            horizontalLineTo(4.735f)
            lineTo(4.387f, 3.169f)
            verticalLineTo(2.812f)
            lineTo(4.014f, 2.369f)
            lineTo(4.016f, 1.964f)
            horizontalLineTo(6.975f)
            lineTo(6.977f, 0.124f)
            horizontalLineTo(7.905f)
            curveTo(8.066f, 0.124f, 8.511f, 0.435f, 8.511f, 0.435f)
            horizontalLineTo(9.264f)
            lineTo(9.612f, 0.79f)
            verticalLineTo(1.147f)
            lineTo(9.985f, 1.59f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFE1E5E8)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(4.014f, 1.59f)
            lineTo(4.016f, 1.996f)
            horizontalLineTo(6.975f)
            lineTo(6.977f, 3.836f)
            horizontalLineTo(7.905f)
            curveTo(8.067f, 3.836f, 8.511f, 3.525f, 8.511f, 3.525f)
            horizontalLineTo(9.264f)
            lineTo(9.612f, 3.169f)
            verticalLineTo(2.812f)
            lineTo(9.985f, 2.369f)
            lineTo(9.983f, 1.964f)
            horizontalLineTo(7.024f)
            lineTo(7.022f, 0.124f)
            horizontalLineTo(6.094f)
            curveTo(5.932f, 0.124f, 5.488f, 0.435f, 5.488f, 0.435f)
            horizontalLineTo(4.735f)
            lineTo(4.387f, 0.79f)
            verticalLineTo(1.147f)
            lineTo(4.014f, 1.59f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFC51918)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(6.002f, 0.685f)
            lineTo(5.97f, 0.529f)
            lineTo(6.608f, 0.382f)
            curveTo(6.685f, 0.345f, 6.818f, 0.24f, 7.001f, 0.068f)
            lineTo(7.087f, 0.165f)
            lineTo(7.101f, 0.148f)
            curveTo(7.284f, 0.32f, 7.417f, 0.425f, 7.494f, 0.462f)
            lineTo(8.132f, 0.609f)
            lineTo(8.1f, 0.765f)
            lineTo(7.746f, 0.692f)
            lineTo(7.78f, 0.723f)
            curveTo(7.756f, 0.737f, 7.729f, 0.758f, 7.701f, 0.786f)
            lineTo(7.551f, 0.764f)
            lineTo(7.565f, 0.714f)
            lineTo(7.528f, 0.707f)
            curveTo(7.5f, 0.759f, 7.469f, 0.834f, 7.435f, 0.929f)
            lineTo(7.286f, 0.885f)
            lineTo(7.346f, 0.595f)
            lineTo(7.008f, 0.278f)
            lineTo(6.772f, 0.5f)
            curveTo(6.801f, 0.527f, 6.831f, 0.557f, 6.86f, 0.592f)
            curveTo(6.835f, 0.601f, 6.811f, 0.61f, 6.788f, 0.617f)
            lineTo(6.778f, 0.62f)
            lineTo(6.816f, 0.805f)
            lineTo(6.667f, 0.849f)
            curveTo(6.647f, 0.793f, 6.629f, 0.745f, 6.611f, 0.704f)
            lineTo(6.599f, 0.706f)
            curveTo(6.57f, 0.678f, 6.544f, 0.657f, 6.52f, 0.643f)
            lineTo(6.562f, 0.605f)
            curveTo(6.555f, 0.593f, 6.548f, 0.583f, 6.542f, 0.574f)
            lineTo(6.002f, 0.685f)
            close()
            moveTo(6.028f, 1.258f)
            lineTo(6.114f, 1.124f)
            lineTo(5.673f, 0.829f)
            lineTo(5.722f, 0.76f)
            lineTo(5.596f, 0.666f)
            lineTo(5.542f, 0.741f)
            lineTo(5.367f, 0.624f)
            lineTo(5.282f, 0.758f)
            lineTo(5.45f, 0.87f)
            lineTo(5.415f, 0.919f)
            lineTo(5.541f, 1.013f)
            lineTo(5.58f, 0.958f)
            lineTo(6.028f, 1.258f)
            close()
            moveTo(5.483f, 1.418f)
            lineTo(5.568f, 1.284f)
            lineTo(5.127f, 0.989f)
            lineTo(5.176f, 0.92f)
            lineTo(5.051f, 0.826f)
            lineTo(4.997f, 0.901f)
            lineTo(4.822f, 0.784f)
            lineTo(4.737f, 0.918f)
            lineTo(4.904f, 1.03f)
            lineTo(4.87f, 1.079f)
            lineTo(4.995f, 1.173f)
            lineTo(5.035f, 1.118f)
            lineTo(5.483f, 1.418f)
            close()
            moveTo(5.249f, 1.898f)
            lineTo(5.334f, 1.764f)
            lineTo(4.894f, 1.469f)
            lineTo(4.943f, 1.4f)
            lineTo(4.817f, 1.306f)
            lineTo(4.763f, 1.381f)
            lineTo(4.588f, 1.264f)
            lineTo(4.503f, 1.398f)
            lineTo(4.671f, 1.51f)
            lineTo(4.636f, 1.559f)
            lineTo(4.762f, 1.653f)
            lineTo(4.801f, 1.598f)
            lineTo(5.249f, 1.898f)
            close()
            moveTo(5.257f, 2.282f)
            lineTo(5.171f, 2.148f)
            lineTo(4.723f, 2.449f)
            lineTo(4.684f, 2.393f)
            lineTo(4.558f, 2.488f)
            lineTo(4.593f, 2.536f)
            lineTo(4.425f, 2.649f)
            lineTo(4.51f, 2.783f)
            lineTo(4.685f, 2.666f)
            lineTo(4.739f, 2.741f)
            lineTo(4.865f, 2.647f)
            lineTo(4.816f, 2.578f)
            lineTo(5.257f, 2.282f)
            close()
            moveTo(5.405f, 2.628f)
            lineTo(5.49f, 2.762f)
            lineTo(5.049f, 3.058f)
            lineTo(5.098f, 3.126f)
            lineTo(4.973f, 3.221f)
            lineTo(4.919f, 3.146f)
            lineTo(4.744f, 3.263f)
            lineTo(4.659f, 3.129f)
            lineTo(4.826f, 3.016f)
            lineTo(4.792f, 2.968f)
            lineTo(4.917f, 2.873f)
            lineTo(4.957f, 2.929f)
            lineTo(5.405f, 2.628f)
            close()
            moveTo(5.951f, 2.788f)
            lineTo(6.036f, 2.922f)
            lineTo(5.595f, 3.218f)
            lineTo(5.644f, 3.286f)
            lineTo(5.518f, 3.381f)
            lineTo(5.464f, 3.306f)
            lineTo(5.289f, 3.423f)
            lineTo(5.204f, 3.289f)
            lineTo(5.372f, 3.176f)
            lineTo(5.337f, 3.128f)
            lineTo(5.463f, 3.033f)
            lineTo(5.503f, 3.089f)
            lineTo(5.951f, 2.788f)
            close()
            moveTo(6.782f, 3.553f)
            curveTo(6.757f, 3.544f, 6.733f, 3.535f, 6.71f, 3.528f)
            lineTo(6.68f, 3.521f)
            lineTo(6.739f, 3.242f)
            lineTo(6.589f, 3.198f)
            curveTo(6.541f, 3.333f, 6.498f, 3.426f, 6.464f, 3.473f)
            lineTo(5.924f, 3.361f)
            lineTo(5.892f, 3.518f)
            lineTo(6.507f, 3.659f)
            lineTo(6.507f, 3.66f)
            lineTo(6.596f, 3.719f)
            lineTo(6.608f, 3.712f)
            curveTo(6.685f, 3.766f, 6.791f, 3.855f, 6.923f, 3.978f)
            lineTo(6.973f, 3.922f)
            lineTo(7.023f, 3.978f)
            curveTo(7.207f, 3.807f, 7.34f, 3.702f, 7.416f, 3.665f)
            lineTo(7.437f, 3.66f)
            curveTo(7.464f, 3.683f, 7.491f, 3.703f, 7.518f, 3.719f)
            lineTo(7.607f, 3.66f)
            lineTo(7.598f, 3.629f)
            lineTo(7.608f, 3.621f)
            lineTo(8.054f, 3.518f)
            lineTo(8.022f, 3.361f)
            lineTo(7.482f, 3.473f)
            curveTo(7.448f, 3.426f, 7.405f, 3.333f, 7.357f, 3.198f)
            lineTo(7.208f, 3.242f)
            lineTo(7.268f, 3.532f)
            lineTo(6.973f, 3.809f)
            lineTo(6.745f, 3.595f)
            curveTo(6.757f, 3.582f, 6.77f, 3.568f, 6.782f, 3.553f)
            close()
            moveTo(8.69f, 2.282f)
            lineTo(8.775f, 2.148f)
            lineTo(9.223f, 2.449f)
            lineTo(9.263f, 2.393f)
            lineTo(9.388f, 2.488f)
            lineTo(9.354f, 2.536f)
            lineTo(9.521f, 2.649f)
            lineTo(9.436f, 2.783f)
            lineTo(9.261f, 2.666f)
            lineTo(9.207f, 2.741f)
            lineTo(9.082f, 2.647f)
            lineTo(9.131f, 2.578f)
            lineTo(8.69f, 2.282f)
            close()
            moveTo(8.456f, 2.762f)
            lineTo(8.541f, 2.628f)
            lineTo(8.989f, 2.929f)
            lineTo(9.029f, 2.873f)
            lineTo(9.154f, 2.968f)
            lineTo(9.12f, 3.016f)
            lineTo(9.288f, 3.129f)
            lineTo(9.202f, 3.263f)
            lineTo(9.027f, 3.146f)
            lineTo(8.973f, 3.221f)
            lineTo(8.848f, 3.126f)
            lineTo(8.897f, 3.058f)
            lineTo(8.456f, 2.762f)
            close()
            moveTo(7.911f, 2.922f)
            lineTo(7.996f, 2.788f)
            lineTo(8.444f, 3.089f)
            lineTo(8.483f, 3.033f)
            lineTo(8.609f, 3.128f)
            lineTo(8.574f, 3.176f)
            lineTo(8.742f, 3.289f)
            lineTo(8.657f, 3.423f)
            lineTo(8.482f, 3.306f)
            lineTo(8.428f, 3.381f)
            lineTo(8.302f, 3.286f)
            lineTo(8.351f, 3.218f)
            lineTo(7.911f, 2.922f)
            close()
            moveTo(8.768f, 1.844f)
            lineTo(8.853f, 1.978f)
            lineTo(9.301f, 1.678f)
            lineTo(9.34f, 1.733f)
            lineTo(9.466f, 1.639f)
            lineTo(9.432f, 1.59f)
            lineTo(9.599f, 1.478f)
            lineTo(9.514f, 1.344f)
            lineTo(9.339f, 1.461f)
            lineTo(9.285f, 1.386f)
            lineTo(9.159f, 1.48f)
            lineTo(9.208f, 1.549f)
            lineTo(8.768f, 1.844f)
            close()
            moveTo(8.534f, 1.364f)
            lineTo(8.619f, 1.498f)
            lineTo(9.067f, 1.198f)
            lineTo(9.107f, 1.253f)
            lineTo(9.232f, 1.159f)
            lineTo(9.198f, 1.11f)
            lineTo(9.366f, 0.998f)
            lineTo(9.28f, 0.864f)
            lineTo(9.105f, 0.981f)
            lineTo(9.051f, 0.906f)
            lineTo(8.926f, 1f)
            lineTo(8.975f, 1.069f)
            lineTo(8.534f, 1.364f)
            close()
            moveTo(7.988f, 1.204f)
            lineTo(8.074f, 1.338f)
            lineTo(8.522f, 1.038f)
            lineTo(8.561f, 1.093f)
            lineTo(8.687f, 0.999f)
            lineTo(8.652f, 0.95f)
            lineTo(8.82f, 0.838f)
            lineTo(8.735f, 0.704f)
            lineTo(8.56f, 0.821f)
            lineTo(8.506f, 0.746f)
            lineTo(8.38f, 0.84f)
            lineTo(8.429f, 0.909f)
            lineTo(7.988f, 1.204f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFC51918)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(6.208f, 1.153f)
            lineTo(7.09f, 0.685f)
            verticalLineTo(1.965f)
            horizontalLineTo(9.272f)
            lineTo(8.752f, 2.339f)
            verticalLineTo(2.829f)
            horizontalLineTo(7.929f)
            lineTo(7.047f, 3.297f)
            verticalLineTo(2.017f)
            horizontalLineTo(4.865f)
            lineTo(5.385f, 1.643f)
            verticalLineTo(1.153f)
            horizontalLineTo(6.208f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF29AE66)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(7.929f, 1.153f)
            lineTo(7.047f, 0.685f)
            verticalLineTo(1.965f)
            horizontalLineTo(4.865f)
            lineTo(5.385f, 2.339f)
            verticalLineTo(2.829f)
            horizontalLineTo(6.208f)
            lineTo(7.09f, 3.297f)
            verticalLineTo(2.017f)
            horizontalLineTo(9.272f)
            lineTo(8.752f, 1.643f)
            verticalLineTo(1.153f)
            horizontalLineTo(7.929f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF29AE66)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(5.779f, 1.485f)
            lineTo(5.923f, 1.201f)
            lineTo(6.289f, 1.397f)
            lineTo(6.39f, 1.247f)
            lineTo(6.647f, 1.428f)
            lineTo(6.568f, 1.546f)
            lineTo(7.652f, 2.126f)
            lineTo(7.719f, 2.026f)
            lineTo(7.975f, 2.208f)
            lineTo(7.931f, 2.275f)
            lineTo(8.048f, 2.337f)
            lineTo(7.904f, 2.621f)
            lineTo(7.752f, 2.54f)
            lineTo(7.629f, 2.723f)
            lineTo(7.373f, 2.541f)
            lineTo(7.474f, 2.391f)
            lineTo(6.389f, 1.811f)
            lineTo(6.3f, 1.944f)
            lineTo(6.044f, 1.762f)
            lineTo(6.111f, 1.662f)
            lineTo(5.779f, 1.485f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFC51918)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(8.09f, 1.407f)
            lineTo(7.926f, 1.134f)
            lineTo(7.574f, 1.355f)
            lineTo(7.463f, 1.212f)
            lineTo(7.22f, 1.411f)
            lineTo(7.307f, 1.523f)
            lineTo(6.266f, 2.177f)
            lineTo(6.192f, 2.082f)
            lineTo(5.949f, 2.282f)
            lineTo(5.998f, 2.345f)
            lineTo(5.886f, 2.416f)
            lineTo(6.049f, 2.689f)
            lineTo(6.195f, 2.597f)
            lineTo(6.33f, 2.771f)
            lineTo(6.573f, 2.572f)
            lineTo(6.462f, 2.429f)
            lineTo(7.503f, 1.775f)
            lineTo(7.601f, 1.901f)
            lineTo(7.845f, 1.702f)
            lineTo(7.771f, 1.607f)
            lineTo(8.09f, 1.407f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFF7FCFF)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(19.073f, 2f)
            curveTo(19.073f, 2f, 21.404f, 7.522f, 19.333f, 9.867f)
            curveTo(17.263f, 12.211f, 12f, 11.759f, 12f, 11.759f)
            curveTo(12f, 11.759f, 18.756f, 14.811f, 21.7f, 10.609f)
            curveTo(24.644f, 6.407f, 19.073f, 2f, 19.073f, 2f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFF7FCFF)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(14.844f, 5.248f)
            lineTo(14.228f, 5.682f)
            lineTo(14.445f, 4.955f)
            lineTo(13.847f, 4.496f)
            lineTo(14.598f, 4.481f)
            lineTo(14.844f, 3.763f)
            lineTo(15.091f, 4.481f)
            lineTo(15.842f, 4.496f)
            lineTo(15.243f, 4.955f)
            lineTo(15.461f, 5.682f)
            lineTo(14.844f, 5.248f)
            close()
            moveTo(14.964f, 7.254f)
            lineTo(14.347f, 7.688f)
            lineTo(14.564f, 6.961f)
            lineTo(13.966f, 6.502f)
            lineTo(14.717f, 6.486f)
            lineTo(14.964f, 5.768f)
            lineTo(15.21f, 6.486f)
            lineTo(15.961f, 6.502f)
            lineTo(15.363f, 6.961f)
            lineTo(15.58f, 7.688f)
            lineTo(14.964f, 7.254f)
            close()
            moveTo(12.473f, 7.843f)
            lineTo(13.089f, 7.409f)
            lineTo(13.706f, 7.843f)
            lineTo(13.488f, 7.115f)
            lineTo(14.087f, 6.656f)
            lineTo(13.336f, 6.641f)
            lineTo(13.089f, 5.923f)
            lineTo(12.843f, 6.641f)
            lineTo(12.092f, 6.656f)
            lineTo(12.69f, 7.115f)
            lineTo(12.473f, 7.843f)
            close()
            moveTo(14.964f, 9.357f)
            lineTo(14.347f, 9.791f)
            lineTo(14.564f, 9.064f)
            lineTo(13.966f, 8.605f)
            lineTo(14.717f, 8.59f)
            lineTo(14.964f, 7.872f)
            lineTo(15.21f, 8.59f)
            lineTo(15.961f, 8.605f)
            lineTo(15.363f, 9.064f)
            lineTo(15.58f, 9.791f)
            lineTo(14.964f, 9.357f)
            close()
            moveTo(16.385f, 7.075f)
            lineTo(17.001f, 6.641f)
            lineTo(17.618f, 7.075f)
            lineTo(17.4f, 6.348f)
            lineTo(17.999f, 5.889f)
            lineTo(17.248f, 5.873f)
            lineTo(17.001f, 5.156f)
            lineTo(16.754f, 5.873f)
            lineTo(16.003f, 5.889f)
            lineTo(16.602f, 6.348f)
            lineTo(16.385f, 7.075f)
            close()
        }
    }.build()
}

@Preview
@Composable
private fun TurkmenistanPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Large.Turkmenistan,
            contentDescription = "Turkmenistan Flag"
        )
    }
}
